import React from 'react'
import '../alertas/alertas.css'
import ReactDOMServer from 'react-dom/server';
import Swal from "sweetalert2"
import Formularios from '../formularios/formularios';
import Usuarios from '../../dashboard/admin/usuarios/usuarios';
import "../../dashboard/admin/admin.css";

const PopUps = () => {

  const popUp1 = () => {
    const reactComponentHtml = ReactDOMServer.renderToString(<Formularios />);

    Swal.fire({
      title: '',
      html: reactComponentHtml,
      width: 1000,
      padding: "1px",
      color: "#716add",
      backdrop: `
        rgba(0,0,0,0.8)
      `,
      customClass: {
        confirmButton: 'btn-ok',
        title: 'alert-title',
        popup: 'alert-bg'
      }
    });    
  }

  const popUp2 = () => {
    const reactComponentHtml = ReactDOMServer.renderToString(
      <div className="main-panel">
        <div className="main-panel-name d-flex">
            <p className="fw-bold ps-2 m-0 align-self-center">Usuarios</p>
        </div>
        <div className="main-panel-body">
            <Usuarios />
        </div>
      </div>
    );

    Swal.fire({
      title: '',
      html: reactComponentHtml,
      width: 800,
      padding: "1em",
      color: "#716add",
      backdrop: `
        rgba(0,0,0,0.8)
      `,
      customClass: {
        confirmButton: 'btn-ok',
        title: 'alert-title',
        popup: 'alert-bg'
      }
    });    
  }

  return (
    <div className='container-fluid d-flex justify-content-center pb-5 border-bottom border-3'>
      <div className='container p-0 mt-3'>
        <div className='container-lg p-0'>
          <div className='py-3'>
            <p className='short-title font-semibold text-premium-blue mt-4'>Pop Ups</p>
          </div>
          <div className='row mt-3 row-gap-3 text-premium-blue'>
            <div className='col-12 col-md-6 d-flex justify-content-center'>
                <button className='btn-amc-ch btn-pink-secondary' onClick={popUp1}>Pop Up 1</button>
            </div>
            <div className='col-12 col-md-6 d-flex justify-content-center'>
                <button className='btn-amc-ch btn-pink-secondary'onClick={popUp2}>Pop Up 2</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PopUps